<template>
  <div>
    <el-popover
        placement="left"
        trigger="hover"
        width="500">
      <!--pre v-html="formatedMetadata" /-->
      <el-table
          :data="parsedMetadata"
          :show-header="false">
        <el-table-column
            property="key" />
        <el-table-column
            property="value" />
      </el-table>
      <i
          slot="reference"
          class="el-icon-view" />
    </el-popover>
  </div>
</template>

<script>
import { startCase } from "lodash";

export default {
  name: "MetadataPopover",
  props: {
    metadata: {
      type: [String, null],
      required: false,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    formatedMetadata() {
      let metadata = this.metadata;

      if (metadata) {
        metadata = JSON.stringify(JSON.parse(metadata), undefined, 4);
        metadata = this.syntaxHighlight(metadata);
      }

      return metadata;
    },
    parsedMetadata() {
      let metadata = this.metadata;
      const result = [];

      if (metadata) {
        metadata = JSON.parse(metadata);
        const keys = Object.keys(metadata);
        for (let i = 0; i < keys.length; i++) {
          result.push({
            key: startCase(keys[i]) + ":",
            value: this.formatValue(metadata[keys[i]]),
          });
        }
      }

      return result;
    },
  },
  methods: {
    startCase,
    formatValue(value) {
      if (typeof value === "boolean") {
        return value ? "ON" : "OFF";
      }
      return value;
    },
    async openModal() {
      this.visible = true;
    },
    syntaxHighlight(json) {
      json = json
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
      return json.replace(
        /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
        (match) => {
          var cls = "number";
          if (/^"/.test(match)) {
            if (/:$/.test(match)) {
              cls = "key";
            } else {
              cls = "string";
            }
          } else if (/true|false/.test(match)) {
            cls = "boolean";
          } else if (/null/.test(match)) {
            cls = "null";
          }
          return '<span class="' + cls + '">' + match + "</span>";
        }
      );
    },
  },
};
</script>

<style lang="scss">
pre {
  outline: 1px solid #ccc;
  padding: 5px;
  margin: 5px;
}
.string {
  color: green;
}
.number {
  color: darkorange;
}
.boolean {
  color: blue;
}
.null {
  color: magenta;
}
.key {
  color: red;
}
</style>
